import { render, staticRenderFns } from "./ReportAnnouncementList.vue?vue&type=template&id=015d7310&scoped=true&"
import script from "./ReportAnnouncementList.vue?vue&type=script&lang=js&"
export * from "./ReportAnnouncementList.vue?vue&type=script&lang=js&"
import style0 from "./ReportAnnouncementList.vue?vue&type=style&index=0&id=015d7310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d7310",
  null
  
)

export default component.exports